import { Alert, Flex, SearchField, Text } from '@aws-amplify/ui-react';
import FlexFormContainer from '../common/FlexFormContainer';
import CareGiverSearchResults from './CareGiverSearchResults';
import { useState } from 'react';

export default function CareGiversAddPage() {
  const [searchUsername, setSearchUsername] = useState('');

  const onSearchSubmit = (searchValue) => {
    setSearchUsername(searchValue);
  };

  return (
    <>
      <FlexFormContainer headerTitle={'Add Caregiver'}>
          <Alert
            variation="info"
            isDismissible={false}
            hasIcon={true}
          >
            Please add the username of the person you would like to add as a
            caregiver. Note that they must also have a Total Care Compass profile
            account to be added.
          </Alert>

        <Flex>
          <SearchField
            placeholder="Search by username..."
            onSubmit={onSearchSubmit}
          />
        </Flex>
        {searchUsername !== '' && (
          <CareGiverSearchResults searchUsername={searchUsername} />
        )}
      </FlexFormContainer>
    </>
  );
}
